import { Inject, Injectable } from '@angular/core';
import {
  CampaignHashtag,
  CampaignHashtagRepository
} from '@infrab4a/connect';
import { ConnectRequest } from 'src/app/models';
import { BaseConnectService } from './base-connect.service';

@Injectable({
  providedIn: 'root'
})
export class CampaignHashtagService extends BaseConnectService<CampaignHashtag> {
  constructor(
    @Inject('CampaignHashtagRepository')
    private campaignHashtagRepository: CampaignHashtagRepository
  ) {
    super(campaignHashtagRepository);
  }

  async getCampaignById(id: string): Promise<CampaignHashtag> {
    return this.campaignHashtagRepository.get({ id });
  }

  async getCampaignsList(request: Partial<ConnectRequest>) {
    const filters = this.getFiltersQuery(request.filters);
    const hasFilters = !!filters && Object.keys(filters).length > 0;
    const result = await this.campaignHashtagRepository.find({
      ...(hasFilters && { filters }),
      options: {
        enableCount: true
      }
    });
    const allItems = (result.data ?? []).map((campaign) => ({ ...campaign }));
    const totalElements = allItems.length;
    const content = this.paginate(allItems, request.page, request.pageSize);

    return {
      totalPages: request.pageSize
        ? Math.floor(totalElements / request.pageSize)
        : undefined,
      totalElements,
      content,
      empty: totalElements === 0
    };
  }

  async saveCampaign(campaign: Partial<CampaignHashtag>) {
    const now = new Date();
    return this.campaignHashtagRepository.create(
      CampaignHashtag.toInstance({
        ...campaign,
        createdAt: campaign.createdAt ?? now,
        updatedAt: now
      })
    );
  }

  async updateCampaign(campaign: Partial<CampaignHashtag>) {
    return this.campaignHashtagRepository.update(
      CampaignHashtag.toInstance({
        ...campaign,
        updatedAt: new Date()
      })
    );
  }

  async deleteCampaign(campaignId: string): Promise<void> {
    return this.campaignHashtagRepository.delete({ id: campaignId });
  }

  private paginate<T>(
    items: T[],
    page?: number,
    pageSize?: number
  ): T[] {
    if (!pageSize) {
      return items;
    }

    const start = (page ?? 0) * pageSize;
    return items.slice(start, start + pageSize);
  }
}
